"use strict";

angular.module("customer")
.service("CustomerOrderService", function(
    $window, $rootScope, $http, $resource, $q, $state, $cookies, CoreOrderService, ReadOnlyPermissionService, FlashBag,
    ModalService, gettextCatalog, appConfig
) {
    function exposeOrderModification(orderId) {
        $http({
            method: "POST",
            url: appConfig.API_SERVER + "/catalog/customer/orders/" + orderId + "/start-modification/"
        }).then(function onSuccess() {
            FlashBag.success(gettextCatalog.getString("You can now modify the order."), true);
            $rootScope.UpdateCurrentNumbers();
            $state.go("shoppingCart");
        }, function onError(response) {
            ReadOnlyPermissionService.handleResponseError(response);
            FlashBag.apiError(response);
        });
    }

    function confirmCancelOrder() {
        $http({
            method: "POST",
            url: appConfig.API_SERVER + "/catalog/customer/orders/cancel/"
        }).then(function onSuccess(response) {
            FlashBag.success(gettextCatalog.getString("The order was cancelled."), true);
            $rootScope.UpdateCurrentNumbers();
            $state.go("orderDetails", {id: response.data.orders[0]['id']});
        }, function onError(response) {
            FlashBag.apiError(response);
        });
    }

    this.query = function(search, page) {
        var service = $resource(appConfig.API_SERVER + "/catalog/customer/orders/list/", {}, {
            query: {
                method: "get",
                isArray: false
            }
        });
        return service.query({
                search: search,
                ordering: "-CreationDate",
                page: page
            },
            function onSuccess(data) {
            },
            function onError(response) {
                FlashBag.apiError(response);
            });
    };

    this.startOrderModification = function(orderId) {
        $http({
            method: "GET",
            url: appConfig.API_SERVER + "/catalog/customer/orders/" + orderId + "/start-modification/"
        }).then(function onSuccess() {
            exposeOrderModification(orderId);
        }, function onError(response) {
            CoreOrderService.showOrderModificationConfirmationModal(response.data.detail)
            .then(function onSuccess() {
                exposeOrderModification(orderId);
            });
        });
    };

    this.cancelOrderModification = function(orderId) {
        // noinspection JSCheckFunctionSignatures,JSVoidFunctionReturnValueUsed
        ModalService.showModal({
            templateUrl: require("core/confirmation/confirmation.modal.html"),
            controller: "Confirmation",
            controllerAs: "ConfirmationCtrl",
            inputs: {
                $attrs: {
                    title: gettextCatalog.getString("Cancel Order Modification Confirmation"),
                    context: gettextCatalog.getString("Your current cart will be emptied."),
                    message: gettextCatalog.getString("Do you want to cancel the modification of this order?")
                }
            }
        }).then(function onSuccess(modal) {
            modal.element.modal();
            modal.element.on("hidden.bs.modal", function(e) {
                modal.element.remove();
            });
            modal.close.then(function onSuccess(result) {
                if (!result) {
                    return
                }

                $http({
                    method: "DELETE",
                    url: appConfig.API_SERVER + "/catalog/customer/orders/" + orderId + "/cancel-modification/"
                }).then(function onSuccess(response) {
                    var orderModifyRedirectUrl = $cookies.get("vendor_orders_url");
                    if (orderModifyRedirectUrl) {
                        $cookies.remove("vendor_orders_url", {domain: appConfig.ROOT_DOMAIN});
                        $window.location.href = orderModifyRedirectUrl + "?order_cancelled=" + response.data.PONumber;
                    }
                    else {
                        FlashBag.success(gettextCatalog.getString("The order modification was cancelled."), true);
                        $rootScope.UpdateCurrentNumbers();
                        $state.go("orderDetails", {id: orderId});
                    }
                }, function onError(response) {
                    ReadOnlyPermissionService.handleResponseError(response);
                    FlashBag.apiError(response);
                });
            });
        });
    };

    this.cancelOrder = function(orderId) {
        // noinspection JSCheckFunctionSignatures,JSVoidFunctionReturnValueUsed
        ModalService.showModal({
            templateUrl: require("core/confirmation/confirmation.modal.html"),
            controller: "Confirmation",
            controllerAs: "ConfirmationCtrl",
            inputs: {
                $attrs: {
                    title: gettextCatalog.getString("Cancel Order Confirmation"),
                    message: gettextCatalog.getString("Do you want to continue the cancellation of this order?")
                }
            }
        }).then(function onSuccess(modal) {
            modal.element.modal();
            modal.element.on("hidden.bs.modal", function(e) {
                modal.element.remove();
            });
            modal.close.then(function onSuccess(result) {
                if (!result) {
                    return
                }

                $http({
                    method: "POST",
                    url: appConfig.API_SERVER + "/catalog/customer/orders/" + orderId + "/cancel/"
                }).then(confirmCancelOrder, function onError(response) {
                    ReadOnlyPermissionService.handleResponseError(response);
                    FlashBag.apiError(response);
                });
            });
        });
    };
});



//////////////////
// WEBPACK FOOTER
// ./customer/sections/order/customer-order.service.js
// module id = 905
// module chunks = 0